<template>
    <table class="text-left w-full border-collapse" id="project_table">
        <thead>
        <tr class="font-bold uppercase text-sm text-grey-darkest border-b border-grey-light">
            <th class="pl-2" v-for="columnToShow in availableColumns">
                <button v-if="availableSort[columnToShow.property_name]" class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none"
                        :class="currentOrder.sortBy === columnToShow.property_name ? 'text-teal' : ''"
                        @click="sortByColumn(columnToShow.property_name)">
                    {{ columnToShow.name }}
                    <i class="fa fa-xs ml-2" :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                            'fa-chevron-down' : currentOrder.direction === 'desc'}"
                       v-if="currentOrder.sortBy === columnToShow.property_name"></i>
                </button>
                <button v-else class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none">
                    {{ columnToShow.name }}
                </button>
            </th>
            <th class="pl-2">
                <button
                    class="font-bold uppercase text-xs text-grey-darkest hover:text-teal hover:no-underline focus:outline-none"
                    :class="currentOrder.sortBy === 'updated_at' ? 'text-teal' : ''"
                    @click="sortByColumn('updated_at')">
                    Last Update
                    <i class="fa fa-xs ml-2"
                       :class="{'fa-chevron-up' : currentOrder.direction === 'asc',
                                    'fa-chevron-down' : currentOrder.direction === 'desc'}"
                       v-if="currentOrder.sortBy === 'updated_at'"></i>
                </button>
            </th>
            <th class="pl-2 border-l-1 text-center" style="width:5%">
                <project-export-icon
                    name="Projects"
                    :projects="{}"
                    :state="columns"
                    :filter="{}"
                    :field-labels="fieldLabels"
                    v-on:contactStateUpdated="updateColumnState"
                    :isListExport="true"
                    :list="list"
                />
            </th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="items.length > 0" v-for="project in items" class="text-sm">
            <td v-for="column in availableColumns" class="pl-2 border-b border-grey-light text-xs md:table-cell td-text-overflow"
                :class="[(column.property_name === 'sequential_team_id' || column.property_name === 'name' || column.property_name === 'contact_name' || column.property_name === 'due_date' || column.property_name === 'address' || column.property_name === 'city' || column.property_name === 'state' || column.property_name === 'zip' || column.property_name === 'contact_email' || column.property_name === 'contact_phone' || column.property_name === 'contact_cell' || column.property_name === 'contact_fax' || column.property_name === 'company_contact_name' || column.property_name === 'company_contact_company_name' || column.property_name === 'company_contact_title' || column.property_name === 'company_contact_email' || column.property_name === 'company_contact_cell' || column.property_name === 'company_contact_followup' || column.property_name === 'company_contact_status') ? 'td-text-overflow' : '']"
            >
                <a v-show="column.property_name === 'contact_email'"
                   :href="`mailto:${project['contact_email'] ? project['contact_email'] : ''}`"
                   class="text-teal hover:text-teal-dark"
                   :class="(column.property_name !== 'sequential_team_id') ? 'text-break' : ''">
                    {{ project['contact_email'] }}
                </a>
                <a v-show="column.property_name === 'contact_phone'"
                   :href="`tel:${project['contact_phone']}`" class="text-teal hover:text-teal-dark"
                   :class="(column.property_name !== 'sequential_team_id') ? 'text-break' : ''">
                    <formatted-phone
                        v-if="project['contact_phone']" :phone="project['contact_phone']" :masks="masks"/>
                </a>
                <a v-show="column.property_name === 'contact_cell'"
                   style="text-decoration: none; color: #49545a;"
                   :class="(column.property_name !== 'sequential_team_id') ? 'text-break' : ''">
                    <formatted-phone
                        v-if="project['contact_cell']" :phone="project['contact_cell']" :masks="masks"/>
                </a>
                <a v-show="column.property_name === 'company_contact_cell'"
                   style="text-decoration: none; color: #49545a;"
                   :class="(column.property_name !== 'sequential_team_id') ? 'text-break' : ''">
                    <formatted-phone
                        v-if="project['company_contact_cell']" :phone="project['company_contact_cell']"
                        :masks="masks"/>
                </a>
                <span
                      v-show="column.property_name !== 'pre_bid' && column.property_name !== 'bid_date' && column.property_name !== 'login_date' && column.property_name !== 'contract_date'&& column.property_name !== 'dead_date' && column.property_name !== 'labor_hours' && column.property_name !== 'base_bid' && column.property_name !== 'contract_amount' && column.property_name !== 'gross_margin' && column.property_name !== 'contact_email' && column.property_name !== 'contact_phone' && column.property_name !== 'contact_cell' && column.property_name !== 'company_contact_cell' && column.property_name !== 'company_contact_followup' && column.property_name !== 'comment' && column.property_name !== 'add_comment' && !column.is_custom_field"
                      :class="(column.property_name === 'name') ? 'fix-name-content' : ''"
                      :title="project[column.property_name]">
                    {{ project[column.property_name] }}
                </span>

                <span
                    @click.stop="column.property_name === 'base_bid' || column.property_name === 'contract_amount' || column.property_name === 'gross_margin' || column.property_name === 'labor_hours'"
                    v-if="column.property_name === 'base_bid' || column.property_name === 'contract_amount' || column.property_name === 'gross_margin' || column.property_name === 'labor_hours'">

                    {{ project[column.property_name] ? (project[column.property_name]).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') : '' }}
                </span>

                <span
                    v-if="column.property_name === 'comment'"
                    :class="(column.property_name === 'name') ? 'fix-name-content' : ''"
                    :title="(project[column.property_name])? project[column.property_name]:''"
                    data-toggle="tooltip" data-placement="auto" data-html="true"
                    class="comment-tooltip"
                    v-html="project[column.property_name] ? project[column.property_name].length >= 20 ? project[column.property_name].substring(0,20) + '..' : project[column.property_name] : project[column.property_name]">
                </span>

                <span @click.stop="column.is_custom_field===true"
                      v-if="column.is_custom_field===true && (column.custom_field_type === 'USER' || column.custom_field_type === 'DROPDOWN' || column.custom_field_type === 'TEXT')">
                    {{ project[column.property_name] }}
                </span>
                <span
                    v-show="column.property_name === 'pre_bid' || column.property_name === 'bid_date' || column.property_name === 'login_date' || column.property_name === 'contract_date' || column.property_name === 'dead_date' || column.property_name === 'company_contact_followup'"
                    :class="(column.property_name === 'name') ? 'fix-name-content' : ''"
                    :title="project[column.property_name]">
                    {{ formatDate(project[column.property_name]) }}
                </span>

                <span
                    v-show="column.is_sales_behavior"
                    :class="(column.property_name === 'name') ? 'fix-name-content' : ''"
                    :title="project[column.property_name]">
                    {{ getSalesBehaviorValue(project.sales_behaviors_data, column.sales_behavior_id) }}
                </span>
            </td>

            <td class="pl-2 border-b border-grey-light text-xs hidden xl:table-cell md:table-cell">
                <div>{{ project.last_update }}</div>
            </td>


            <td class="px-4 text-right hidden md:table-cell border-l-1 cursor-pointer border-b border-grey-light" @click="goToProject(project)">
                <span class="material-icons">chevron_right</span>
            </td>
        </tr>
        <tr v-else class="text-center"><td colspan="9">No record found!</td></tr>
        </tbody>
    </table>
</template>
<script>

import FormattedPhone from '../../shared/formatted-phone.vue';
import ProjectExportIcon from "../../project/project-export-icon";

export default {
    name: 'project',
    props: [
        'availableColumns',
        'availableSort',
        'items',
        'masks',
        'list',
        'projectCustomFields',
        'projectCustomFieldTypeConstants',
        'currentOrder',
        'projectSalesBehaviors',
        'fieldLabels',
    ],
    components: {ProjectExportIcon, FormattedPhone},
    data () {
        let projectState = this.list.states
        const stateCustomFields = this.projectCustomFields.map(customField => ({
            name: customField.label_value,
            checked: true,
            property_name: customField.name,
            is_custom_field: true,
            custom_field_id: customField.id,
            custom_field_type: this.projectCustomFieldTypeConstants[customField.type],
        }));
        const stateSalesBehaviors = this.projectSalesBehaviors.map(salesBehavior => ({
            name: salesBehavior.name,
            checked: true,
            property_name: salesBehavior.name,
            is_sales_behavior: true,
            sales_behavior_id: salesBehavior.id,
        }));
        const proposalDeliveredSalesBehavior = _.find(this.projectSalesBehaviors, ['proposal_delivered', 1]);
        let newState = [
            {
                name: 'ID',
                checked: true,
                property_name: 'sequential_team_id',
            },
            {
                name: 'Project Name',
                checked: true,
                property_name: 'name',
            },
            {
                name: 'Project Contact',
                checked: true,
                property_name: 'contact_name',
            },
            {
                name: 'Due Date ('+proposalDeliveredSalesBehavior ? proposalDeliveredSalesBehavior.name : ''+')',
                checked: true,
                property_name: 'due_date',
            },
            {
                name: 'Status',
                checked: true,
                property_name: 'sales_statuses_code',
            },
            {
                name: 'Base Bid',
                checked: true,
                property_name: 'base_bid',
            },
            {
                name: 'Address',
                checked: true,
                property_name: 'address',
            },
            {
                name: 'City',
                checked: true,
                property_name: 'city',
            },
            {
                name: 'State',
                checked: true,
                property_name: 'state',
            },
            {
                name: 'Zip',
                checked: true,
                property_name: 'zip',
            },
            {
                name: 'Contract Amount',
                checked: true,
                property_name: 'contract_amount',
            },
            {
                name: 'Contract Date',
                checked: true,
                property_name: 'contract_date',
            },
            {
                name: 'Login Date',
                checked: true,
                property_name: 'login_date',
            },
            {
                name: 'Gross Margin',
                checked: true,
                property_name: 'gross_margin',
            },
            {
                name: 'Labor Hours',
                checked: true,
                property_name: 'labor_hours',
            },
            {
                name: 'Dead Date',
                checked: true,
                property_name: 'dead_date',
            },
            {
                name: 'Pre Bid',
                checked: true,
                property_name: 'pre_bid',
            },
            {
                name: 'Bid Date',
                checked: true,
                property_name: 'bid_date',
            },
            {
                name: 'Marketing Status',
                checked: true,
                property_name: 'marketing_status',
            },
            {
                name: 'Project Email',
                checked: true,
                property_name: 'contact_email',
            },
            {
                name: 'Project Phone',
                checked: true,
                property_name: 'contact_phone',
            },
            {
                name: 'Project Cell',
                checked: true,
                property_name: 'contact_cell',
            },
            {
                name: 'Project Fax',
                checked: true,
                property_name: 'contact_fax',
            },
            {
                name: 'Company Contact',
                checked: true,
                property_name: 'company_contact_name',
            },
            {
                name: 'Company',
                checked: true,
                property_name: 'company_contact_company_name',
            },
            {
                name: 'Contact Title',
                checked: true,
                property_name: 'company_contact_title',
            },
            {
                name: 'Contact Email',
                checked: true,
                property_name: 'company_contact_email',
            },
            {
                name: 'Contact Cell',
                checked: true,
                property_name: 'company_contact_cell',
            },
            {
                name: 'Contact Follow Up',
                checked: true,
                property_name: 'company_contact_followup',
            },
            {
                name: 'Contact Status',
                checked: true,
                property_name: 'company_contact_status',
            },
            {
                name: 'Marketing Status',
                checked: true,
                property_name: 'marketing_status',
            },
            {
                name: 'Lead From',
                checked: true,
                property_name: 'lead_from',
            },
            {
                name: 'Client Profile',
                checked: true,
                property_name: 'client_profile',
            },
            {
                name: 'Contract Type',
                checked: true,
                property_name: 'contract_type',
            },
            {
                name: 'Office',
                checked: true,
                property_name: 'office',
            },
            {
                name: 'Products & Services',
                checked: true,
                property_name: 'products_and_services',
            },
            {
                name: 'Estimator',
                checked: true,
                property_name: 'estimator_name',
            },
            {
                name: 'Account Manager',
                checked: true,
                property_name: 'account_manager_name',
            },
            {
                name: 'Take Off Person',
                checked: true,
                property_name: 'take_off_person_name',
            },
            {
                name: 'comment',
                checked: true,
                property_name: 'comment',
            },
            ...stateCustomFields,
            ...stateSalesBehaviors,
        ];
        // let newState = [];
        // if (projectState) {
        //     projectState = projectState.filter((state) => {
        //         return (state.property_name !== "age" && state.property_name !== "meeting_date")
        //     })
        //     const stateHash = projectState.reduce(function (map, obj) {
        //         map[obj.name] = obj;
        //         return map;
        //     }, {});
        //     newState = Object.values(stateHash);
        // } else {
        //     const baseStateHash = newState.reduce(function (map, obj) {
        //         map[obj.name] = obj;
        //         return map;
        //     }, {});
        //     newState = Object.values(baseStateHash);
        // }
        return {
            columnsToExport: [],
            columns: projectState ? projectState : newState,
            sortOrder: this.currentOrder,
            dateFormat: this.calendar? 'MM/DD/yyyy hh:mm:ss A' : 'MM/DD/yyyy',
        }
    },
    created() {
    },
    methods: {
        goToProject(project) {
            window.location = route('project.edit', {project: project.id})
        },
        updateColumnState(updatedStates) {
            this.columnsToExport = updatedStates.filter((updatedState) => {
                if(updatedState.checked){
                    return updatedState
                }
            })
            this.$emit('columnsToExportUpdated', this.columnsToExport);
        },
        sortByColumn(sortBy) {
            const self = this;
            if (sortBy === self.sortOrder.sortBy) {
                self.sortOrder.direction = (self.sortOrder.direction === 'asc') ? 'desc' : 'asc'
            } else {
                self.sortOrder.sortBy = sortBy
                self.sortOrder.direction = 'desc';
            }
            self.$emit('sortingUpdated', self.sortOrder);
        },
        getSalesBehaviorDate(column, salesBehaviors) {
            let date = null;
            let self = this;
            _.forEach(salesBehaviors, function(data) {
                if(data.id === column.sales_behavior_id) {
                    if(data.date && data.date !== ""){
                        date = moment(data.date).format(self.dateFormat)
                    }
                }
            });
            return date;
        },
        getCustomFieldValue(customFieldsData, fieldId) {

            for (var i = 0; i < customFieldsData.length; i++) {

                if (customFieldsData[i].id === fieldId) {

                    return customFieldsData[i].value;
                }
            }
        },
        formatDate(date) {
            if(moment(date).isValid()) {
                return moment(date).format(this.masks.moment_mask)
            }else{
                return ''
            }
        },
        getSalesBehaviorValue(salesBehaviorData, fieldId) {
            let self = this;
            for (var i = 0; i < salesBehaviorData.length; i++) {

                if (salesBehaviorData[i].id === fieldId) {
                    if(salesBehaviorData[i].value && moment(salesBehaviorData[i].value).isValid())
                    {
                        return moment(salesBehaviorData[i].value).format(self.masks.full_date_time_mask);
                    }else{
                        return salesBehaviorData[i].value;
                    }
                }
            }
        },
    }
}
</script>
